<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
      ref="queryFrame"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>消息标题:</label>
            <lk-input clearable placeholder="请输入" v-model='queryParams.title' class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>消息状态:</label>
            <lk-select class="item" v-model='queryParams.dealStatus'>
              <lk-option v-for="(type, index) in messageType" :value="index+1" :key="index">{{type}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>推送日期:</label>
            <timeStampDatePicker  v-model='queryParams.sendTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-tabs v-model="queryParams.messageType" type="card" @on-click="onTabClick">
          <lk-tab-pane :label="announcementLabel" name="1">
            <lk-table border :columns='announcementColumns' :data='announcementData'></lk-table>
          </lk-tab-pane>
          <lk-tab-pane :label="approvalLabel" name="2">
            <lk-table border :columns='commonColumns' :data='approvalData'></lk-table>
          </lk-tab-pane>
          <!-- <lk-tab-pane :label="goodsLabel" name="3">
            <lk-table border :columns='warnColumns' :data='goodsWarnData'></lk-table>
          </lk-tab-pane> -->
          <lk-tab-pane :label="cardLabel" name="4">
            <lk-table border :columns='warnColumns' :data='cardWarnData'></lk-table>
          </lk-tab-pane>
          <lk-tab-pane :label="otherLabel" name="5">
            <lk-table border :columns='otherColumns' :data='otherData'></lk-table>
          </lk-tab-pane>
          <lk-tab-pane :label="expireLabel" name="6">
            <lk-table border :columns='warnColumns' :data='expireData'></lk-table>
          </lk-tab-pane>
          <lk-tab-pane :label="inventoryLabel" name="7">
            <lk-table border :columns='warnColumns' :data='inventoryData'></lk-table>
          </lk-tab-pane>
          <lk-tab-pane :label="retailDailyLabel" name="8">
            <lk-table border :columns='warnColumns' :data='retailDailyData'></lk-table>
          </lk-tab-pane>
        </lk-tabs>
      </div>
    </QueryFrame>
  </div>
</template>
<script>

import message from '../../services/message';
import utils from '../../libs/utils';
import QueryFrame from '../../components/frame/QueryFrame.vue';
// 未引入mixin后期需优化
export default {
  name: 'waitingReceipt',
  components: {
    QueryFrame,
  },
  data() {
    return {
      announcementColumns: [
        {
          title: '公告内容',
          key: 'title',
          render: (h, { row }) => {
            let href = '';
            if (row.businessUrl) {
              href = `${row.businessUrl}`;
            }
            // console.log(href);
            // debugger;
            // return
            return h('a',
              {
                domProps: {
                  href,
                },
                on: {
                  click: () => {
                    message.messageDeal({ messageId: row.id });
                    // this.$router.push({ path: href });
                  },
                },
                style: {
                  paddingLeft: '4px',
                  paddingRight: '4px',
                },
              }, row.title);


            // h('lk-button',
            //   {
            //     props: {
            //       type: 'text',
            //       ghost: true,
            //     },
            //     on: {
            //       click: () => {
            //         message.messageDeal({ messageId: row.id });
            //         this.$router.push({ path: href });
            //       },
            //     },
            //   }, row.title);
          },
        },
        { title: '时间', key: 'sendTime' },
      ],
      messageTypeArr: ['公告消息', '待审批事务', '商品预警', '证件预警', '其他'],
      commonColumns: [
        { title: '审批内容', key: 'title' },
        { title: '时间', key: 'sendTime' },
        {
          title: '操作',
          render: (h, { row }) => {
            let href = '';
            let name = '去处理';
            let disabled = false;
            if (row.dealStatus == 1 || row.dealStatus == 3) {
              name = '已处理';
              disabled = true;
            }
            if (row.businessUrl) {
              href = `${row.businessUrl}`;
            }
            if (disabled) {
              return h('lk-button',
                {
                  props: {
                    disabled,
                    type: 'text',
                  },
                }, name);
            }
            return h('a',
              {
                domProps: {
                  href,
                },
                style: {
                  paddingLeft: '4px',
                  paddingRight: '4px',
                },
              }, name);
          },
        },
      ],
      warnColumns: [
        { title: '预警消息', key: 'title' },
        { title: '时间', key: 'sendTime' },
        {
          title: '操作',
          render: (h, { row }) => {
            let href = '';
            let name = '去处理';
            let disabled = false;
            if (row.dealStatus == 1 || row.dealStatus == 3) {
              name = '已处理';
              disabled = true;
            }
            if (row.businessUrl) {
              href = `${row.businessUrl}`;
            }
            if (disabled) {
              return h('lk-button',
                {
                  props: {
                    disabled,
                    type: 'text',
                  },
                }, name);
            }
            return h('a',
              {
                domProps: {
                  href,
                },
                style: {
                  paddingLeft: '4px',
                  paddingRight: '4px',
                },
              }, name);
          },
        },
      ],
      otherColumns: [
        { title: '消息', key: 'title' },
        { title: '时间', key: 'sendTime' },
        {
          title: '操作',
          render: (h, { row }) => {
            let href = '';
            let name = '去处理';
            let disabled = false;
            if (row.dealStatus == 1 || row.dealStatus == 3) {
              name = '已处理';
              disabled = true;
            }


            if (row.businessUrl) {
              href = `${row.businessUrl}`;
              href = utils.handleMessagePathChange(href, '/baseInfo/patient/patientEdit/', '/baseInfo/patient/patientBase/patientEdit/');
              href = utils.handleMessagePathChange(href, '/baseInfo/patient/patientCheck/', '/baseInfo/patient/patientBase/patientCheck/');
            }
            if (disabled) {
              return h('lk-button',
                {
                  props: {
                    disabled,
                    type: 'text',
                  },
                }, name);
            }
            console.log(href);

            return h('a',
              {
                domProps: {
                  href,
                },
                // props:{
                //   to:href
                // },
                style: {
                  paddingLeft: '4px',
                  paddingRight: '4px',
                },
                on: {
                  click: () => {
                    console.log(123);
                    row.businessType === 'patient_rebuy_un_rebuy' && message.messageDeal({ messageId: row.id }).then(() => {

                    });
                  },
                },
              }, name);
          },
        },
      ],
      messageType: ['已处理', '未处理', '过期'],
      announcementData: [],
      approvalData: [],
      // goodsWarnData: [],
      cardWarnData: [],
      otherData: [],
      expireData: [],
      inventoryData: [],
      retailDailyData: [],
      queryParams: {
        title: '',
        dealStatus: '',
        sendTime: null,
        messageType: '1',
        // 1: 公告类，2: 审核提醒，3: 商品预警，4: 证照过期，5: 其他
      },
      page: 1,
      size: 20,
      count: 0,
      announcementDot: false,
      announcementLabel: h => h('div', [
        h('lk-badge',
          {
            props: {
              dot: this.announcementDot,
            },
          },
          [
            h('span', '公告消息'),
          ]),
      ]),
      approvalDot: false,
      approvalLabel: h => h('div', [
        h('lk-badge',
          {
            props: {
              dot: this.approvalDot,
            },
          },
          [
            h('span', '待审批事务'),
          ]),
      ]),
      // goodsDot: false,
      // goodsLabel: h => h('div', [
      //   h('lk-badge',
      //     {
      //       props: {
      //         dot: this.goodsDot,
      //       },
      //     },
      //     [
      //       h('span', '商品预警'),
      //     ]),
      // ]),
      inventoryLabel: h => h('div', [
        h('lk-badge',
          {
            props: {
              dot: this.inventoryDot,
            },
          },
          [
            h('span', '库存预警'),
          ]),
      ]),
      inventoryDot: false,
      expireLabel: h => h('div', [
        h('lk-badge',
          {
            props: {
              dot: this.expireDot,
            },
          },
          [
            h('span', '效期预警'),
          ]),
      ]),
      expireDot: false,
      cardDot: false,
      cardLabel: h => h('div', [
        h('lk-badge',
          {
            props: {
              dot: this.cardDot,
            },
          },
          [
            h('span', '证件预警'),
          ]),
      ]),
      otherDot: false,
      otherLabel: h => h('div', [
        h('lk-badge',
          {
            props: {
              dot: this.otherDot,
            },
          },
          [
            h('span', '其他'),
          ]),
      ]),
      retailDailyDot: false,
      retailDailyLabel: h => h('div', [
        h('lk-badge',
          {
            props: {
              dot: this.retailDailyDot,
            },
          },
          [
            h('span', '零售日报'),
          ]),
      ]),
    };
  },
  methods: {
    onTabClick() {
      this.page = 1;
      this.getData();
      this.fetchTabStatus();
    },
    fetchTabStatus() {
      const param = {
        messageTypes: '1,2,4,5,6,7,8',
      };
      message.messageCount(param).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          this.announcementDot = !!data['1'];
          this.approvalDot = !!data['2'];
          // this.goodsDot = !!data['3'];
          this.cardDot = !!data['4'];
          this.otherDot = !!data['5'];
          this.expireDot = !!data['6'];
          this.inventoryDot = !!data['7'];
          this.retailDailyDot = !!data['8'];
        } else {
          this.$Message.error(res.data.error);
        }
      })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handleSearch() {
      this.page = 1;
      this.getData();
    },
    getData() {
      const params = Object.assign({}, this.queryParams);
      params.page = this.page;
      params.size = this.size;
      // params.sendTime = utils.exchangeDate(params.sendTime);

      message.messageList(params).then((res) => {
        if (res.data.status === 200) {
          const tempArr = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item.record, result);
            if (result.businessUrl[0] !== '/') { // 防止后端传参错误
              result.businessUrl = `/${result.businessUrl}`;
            }
            result.businessUrl = `${window.location.origin + window.location.pathname}#${result.businessUrl}`;
            result.sendTime = utils.formatTime(result.sendTime, 'YYYY/MM/DD HH:mm');
            tempArr.push(result);
          });
          if (params.messageType == '1') {
            this.announcementData = tempArr;
          } else if (params.messageType == '2') {
            this.approvalData = tempArr;
          } else if (params.messageType == '3') {
            // this.goodsWarnData = tempArr;
          } else if (params.messageType == '4') {
            this.cardWarnData = tempArr;
          } else if (params.messageType == '5') {
            this.otherData = tempArr;
          } else if (params.messageType == '6') {
            this.expireData = tempArr;
          } else if (params.messageType == '7') {
            this.inventoryData = tempArr;
          } else if (params.messageType == '8') {
            this.retailDailyData = tempArr;
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    handlePage(page) {
      this.page = page;
      this.getData();
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
    clear() {
      this.queryParams = {
        title: '',
        dealStatus: '',
        sendTime: null,
        messageType: this.queryParams.messageType,
      };
    },
  },
  created() {
    this.getData();
    this.fetchTabStatus();
  },
};
</script>
<style lang="less" scoped>
</style>
